export default "__VITE_ASSET__CNhMKeDx__"